<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Ordered From Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Ordered To Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-2" style="margin-top: 3%;">
        <button mat-raised-button color="primary" (click)="serveDailySale()" class="button-class"
          style="font-size: 20px;" [disabled]="from_date == null || to_date == null">Search</button>
        <mat-spinner [diameter]="40" *ngIf="data_loading"></mat-spinner>
      </div>
      <div class="col-2" *ngIf="is_data_available" style="margin-top: 3%;">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
            class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div>
  </div>
  <div *ngIf="is_data_available">
    <div class="row" *ngFor="let date of sale_date_list">
      <div class="col-12">
        <label>{{ date['date']}} </label>
      </div>
      <div class="col-12">
        <div class="card" style="padding: 10px;">
          <table class="table table-bordered table-hover">
            <thead style="background: bisque;">
              <tr>
                <th>S.No</th>
                <th>Product </th>
                <th>O/B</th>
                <th>Received</th>
                <th>Total</th>
                <th>Sale</th>
                <th>C/B</th>
              </tr>
            </thead>
            <tbody *ngIf="!sale_data.hasOwnProperty(date['date'])">
              <tr>
                <td colspan="9">
                  No Data Available !!!
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="sale_data.hasOwnProperty(date['date'])">
              <tr *ngFor="let sale of sale_data[date['date']];  let sale_index=index">
                <td>{{ sale_index + 1 }}</td>
                <td>{{ sale['product_name'] }}</td>
                <td>{{ sale['opening_quantity'] }}</td>
                <td>{{ sale['received_quantity'] }}</td>
                <td>{{ sale['total_quantity'] }}</td>
                <td>
                  {{ sale['sales_quantity'] }}
                </td>
                <td>{{ sale['closing_quantity'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
